module.exports = __webpack_public_path__ + "img/goods-bg-W3mkDdCy.7f782bd0.png";